import React from 'react';
import { navigate,url } from 'js/services/Network';
import AppUser from 'js/stores/AppUser';
import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Constraint from 'js/components/Constraint';
import AppState from "js/stores/AppState";
import { AvForm, AvGroup, AvInput, AvFeedback } from 'availity-mobx-reactstrap-validation';
import Button from 'js/components/common/Button';
import FormState from 'js/stores/forms/LoginSignupDialogForm';
import ErrorDisplay from "js/components/common/ErrorDisplay";
import analytics from "js/services/Analytics";
import FacebookConnectButton from "js/components/common/LoginSignupDialog/FacebookConnectButton";
import GoogleConnectButton from "js/components/common/LoginSignupDialog/GoogleConnectButton";
import {GoogleLogin} from "react-google-login";
import LoginSignupDialog from "js/components/common/LoginSignupDialog";
import {EyeOpenIcon, LockIcon} from "js/components/core/Icons/Eye";

const noop = () => true;

export default class SPPOnboardLogin extends PageComponent {
  passwordInput = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      singleUseToken: null,
      showPassword: false,
    }
    this.page = FormState.create();
  }
  pageName = 'SPPOnboardLogin';
  redirect = (link) => navigate(url(link?link:'psp-onboard','',''))

  togglePasswordVisibility = () => {
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };
  pageEvent = () => {
    if (AppUser.isLoggedIn){
      // console.log("Already logged in, redirect to onboard page")
      this.redirect('psp-onboard')
    }else{
      // console.log("Login required")
    }
  }
  formState = FormState.create();

  after = (response) => {
    // console.log("response",response);
    return (noop)(AppUser.email);
  };

  formSubmitted = (event, errors, formValues) => {
    event.preventDefault();
    this.formState.clearError();
    if (!errors.length && !this.formState.requestInProgress){
      this.formState.setIsRequesting();
      this.formValues = formValues;

      AppUser.loginUser(null, formValues)
        .then(this.after)
        .catch(error => {
          this.formState.setIsRequesting(false);
          console.log(error);
          if (error.response && error.response.data && error.response.data.message) {
            this.formState.setError(error.response.data.message);
            this.setState({errorMessage: error.response.data.message})
            // console.log("Error set for display: ",this.state.errorMessage)
          }else{
            this.formState.setError('Invalid Credentials');
            this.setState({errorMessage: 'Invalid Credentials'})
            // console.log("Error set for display: ",this.state.errorMessage)
          }
        })
    }
  }


  renderPage() {
    const { showForm, setError, error, requestInProgress, showForgotPassword, toggleDisplay, closeSafariWarning } = this.formState;
    const before = this.props.before || noop;
    const page = this.props.page;
    const mseller = null;
    const { showPassword } = this.state;

    return (
      <AppContent className="seller-link-page" padded>
        <div className="pod-container">
          <div className="d-flex flex-column flex-md-row justify-content-between">
            <div className="store-container">
              <div className="tw-flex tw-items-center tw-justify-between">
                <h6 className="tw-font-semibold tw-text-xl tw-text-primary">Login</h6>
                <p className="tw-text-sm">
                  <span className="tw-text-[#2C353CB2]">Don't have an account?</span>{" "}
                  <span className="tw-text-secondary" onClick={event => {
                    event.preventDefault();
                    AppState.showLoginSignup('signup')
                  }} style={{cursor:'pointer'}}>Sign Up</span>
                </p>
              </div>
              <div className="tw-max-w-lg tw-mx-auto tw-mt-12">
                <AvForm className="tw-w-full" onSubmit={this.formSubmitted}>
                  <AvGroup className="tw-w-full">
                    <label
                      htmlFor="email"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Enter your email
                    </label>
                    <AvInput
                      type="email"
                      id="email"
                      name="email"
                      required validate={{ email: true }}
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder="Enter your email address"
                    />
                    <AvFeedback>Please enter your email address.</AvFeedback>
                  </AvGroup>
                  <AvGroup className="tw-w-full tw-mt-6" style={{ position: 'relative' }}>
                    <label
                      htmlFor="password"
                      className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                      Enter your password
                    </label>
                    <AvInput
                      type={showPassword ? 'text' : 'password'}
                      id="password"
                      name="password"
                      maxLength={72} required
                      innerRef={this.passwordInput}
                      aria-describedby="tw-helper-text-explanation"
                      className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                      placeholder="Enter your password"
                    />
                    <>
                      <div style={{ position: 'absolute', top: '70%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                        {showPassword
                          ? <LockIcon onClick={this.togglePasswordVisibility} />
                          : <EyeOpenIcon onClick={this.togglePasswordVisibility} />}
                      </div>
                    </>
                    <AvFeedback>Please enter your password.</AvFeedback>
                  </AvGroup>
                  <Button className="tw-bg-secondary tw-py-3 tw-w-full tw-rounded-lg tw-mt-6" type="submit"
                          isLoading={requestInProgress}>
                    {'Log In'}
                    {/*<Link className="tw-text-white tw-font-semibold" to={''}>Log In</Link>*/}
                  </Button>
                  <ErrorDisplay>{this.state.errorMessage}</ErrorDisplay>
                </AvForm>
                <div className="tw-my-10 tw-flex tw-items-center">
                  <div className="tw-w-full tw-h-[1px] tw-bg-outline"></div>
                  <div className="tw-block tw-px-3 tw-text-sm tw-font-medium tw-text-[#6C7277] tw-flex-shrink-0">
                    or login with
                  </div>
                  <div className="tw-w-full tw-h-[1px] tw-bg-outline"></div>
                </div>
                <div>
                  <LoginSignupDialog
                    padded={undefined}
                    showButtonsOnly={true}
                  />
                  {/*<button*/}
                  {/*  className="tw-mt-3 tw-py-3 tw-border tw-border-secondary tw-flex tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-rounded-lg">*/}
                  {/*  <img*/}
                  {/*    src="/images/icons/Google.png"*/}
                  {/*    alt="google icon"*/}
                  {/*    className="tw-w-[20px] tw-h-[20px]"*/}
                  {/*  />*/}
                  {/*  <span className="tw-text-primary">*/}
                  {/*    Continue with google*/}
                  {/*  </span>*/}
                  {/*</button>*/}


                  {/*<GoogleLogin*/}
                  {/*  clientId={window.app.googleSignInClientId}*/}
                  {/*  render={renderProps => (*/}
                  {/*    <GoogleConnectButton*/}
                  {/*      id="gSignInWrapper"*/}
                  {/*      callParentClick={renderProps.onClick}*/}
                  {/*      page={page}*/}
                  {/*      mseller={mseller}*/}
                  {/*    >*/}
                  {/*      {'Continue with google'}*/}
                  {/*    </GoogleConnectButton>*/}
                  {/*  )}*/}
                  {/*  onSuccess={this.googleOnSuccess}*/}
                  {/*  onFailure={(error) => console.log('error', error)}*/}
                  {/*  cookiePolicy={'single_host_origin'}*/}
                  {/*/>*/}
                  {/*<FacebookConnectButton*/}
                  {/*  className="tw-mt-3 tw-py-3 tw-border tw-border-secondary tw-flex tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-rounded-lg"*/}
                  {/*  onConnect={this.runAfterTask}*/}
                  {/*  onError={setError}*/}
                  {/*  beforeConnect={this.beforeConnect}*/}
                  {/*  page={page}*/}
                  {/*  addParams={{*/}
                  {/*    single_use_token: this.state.singleUseToken,*/}
                  {/*  }}*/}
                  {/*>*/}
                  {/*  {'Continue with facebook'}*/}
                  {/*</FacebookConnectButton>*/}



                  {/*<button*/}
                  {/*  className="tw-mt-3 tw-py-3 tw-border tw-border-secondary tw-flex tw-items-center tw-justify-center tw-gap-3 tw-w-full tw-rounded-lg">*/}
                  {/*  <img*/}
                  {/*    src="/images/icons/facebook.png"*/}
                  {/*    alt="facebook icon"*/}
                  {/*    className="tw-w-[10px] tw-h-[19px]"*/}
                  {/*  />*/}
                  {/*  <span className="tw-text-secondary">*/}
                  {/*    Continue with facebook*/}
                  {/*  </span>*/}
                  {/*</button>*/}
                </div>
              </div>
            </div>
            <div className="added-item">

              <div className="tw-hidden md:tw-block tw-w-full tw-h-[586px] tw-bg-[url('/images/ssp/bg-desktop.png')] tw-bg-no-repeat tw-bg-cover"></div>
              <div className="md:tw-hidden tw-h-[300px] tw-w-full tw-bg-[url('/images/ssp/bg-mobile.png')] tw-bg-no-repeat tw-bg-cover tw-mt-20"></div>
            </div>
          </div>
        </div>
      </AppContent>
    );
  }
}
